"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPY = function FlagPY(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-23.13A35.31,35.31,0,1,0,47.11,12.18,35.31,35.31,0,0,0,11.8-23.13Zm0,61.94A26.63,26.63,0,1,1,38.43,12.18,26.63,26.63,0,0,1,11.8,38.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.05,12.18A12.25,12.25,0,1,1,11.8-.07,12.25,12.25,0,0,1,24.05,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.6,2.9l2,5.92,6.24,0a.84.84,0,0,1,.49,1.52l-5,3.7L18.17,20a.85.85,0,0,1-1.3.94L11.8,17.36,6.72,21A.84.84,0,0,1,5.43,20l1.89-5.95-5-3.7a.84.84,0,0,1,.49-1.52L9,8.82,11,2.9a.85.85,0,0,1,1.6,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35,12.46s.7-3.23-2.75.65a16.76,16.76,0,0,0,0-2c.75-.82,1.69-2.61,1.47-6.44,0,0-.54-3.26-2.31,1.61a12.9,12.9,0,0,0-1-2.23c.43-.89.76-2.5-.27-5.56,0,0-1.2-2.62-1.57,1.88a8.15,8.15,0,0,0-1.62-1.84c.12-.72,0-2-1.42-4,0,0-1.44-1.62-.71,1.7,0,0-1.32-1.07-1.75-.94-.22-.63-.85-1.7-3-3.11,0,0-1.84-1,.27,1.62,0,0-1.87-.74-1.85-.32s.93,1.21,1.67,1.57c0,0-2.74.28-1.61.89,0,0,2.78,1,4.45,0a3.35,3.35,0,0,0,.82,1.43s-3.27-.64-2.39.34A8.12,8.12,0,0,0,26.25-.72a4.82,4.82,0,0,0,.55,2.17S22.9-.63,23.64,1c0,0,2.33,3.11,5.43,3.79a5.53,5.53,0,0,0,0,2.22s-3.7-3.49-3.36-1.5c0,0,1.55,4.1,4.68,5.84A6,6,0,0,0,29.89,13s-2.15-4.61-2.57-2.63c0,0-.07,4.61,2.39,7.36a5.65,5.65,0,0,0-1.36,1.64s-.46-5.07-1.52-3.35c0,0-1.47,3.84-.48,7.15a5.75,5.75,0,0,0-1.89,1s1.56-4.84-.09-3.68c0,0-2.94,3.19-3.17,6.76a5.55,5.55,0,0,0-2.6.72s2.24-4.56.44-3.65c0,0-3.2,2.62-4,6l-3.34,1.9c-.74-.44-1.47-.86-2.1-1.22l0,0L2.31,24.79l.14,2-3.66-6.54-.45,2.22-1.2-7.23L-3.92,16.3l.41-6.75-1.39.75,2.52-5-1.18.33,3.11-3-1.64.14L1.84,1,.4.77,4.24-1.18,2.58-1.25,7.56-3l-.91-.79L11-5l-5.16-.4L7.26-7.25l-3.93,2,.56-2.72L.44-4.41l.61-2.48L-2.18-3.68-2-6.11-5.16-.71l-.41-2.41L-8.21,2.94-8.95.3l-1.18,7.51-1-1.12,1.29,7.25-1.64-1.23,3,6.5a23.73,23.73,0,0,0-2.46-.95c-.28,0,5.24,5.6,5.24,5.6l-2.88-.31L-3,27.46-5,28l4.62,1.8-1.13.88L8,31.33s.92.77,2.18,1.66l-1.61.9A1.37,1.37,0,0,1,7.42,34L4.56,32.77a2.86,2.86,0,0,0,2.89,2.8A9.36,9.36,0,0,0,11.68,34c1.51,1,3.18,1.78,4.39,1.75a2.83,2.83,0,0,0,2.83-2.79L16.1,34.1A1.3,1.3,0,0,1,15,34l-1.78-1c.76-.52,1.39-1,1.84-1.33.7.55,2.69,1.51,7.15-.16,0,0,3-1.49-2.22-1.73a15.62,15.62,0,0,0,1.61-1.38c.85.44,2.95,1,7-1.23,0,0,2.72-1.9-2.45-1.4a16.53,16.53,0,0,0,1.23-1.35c.9.09,3.09-.15,6-3.88,0,0,1.76-2.81-2.79-.31a13.09,13.09,0,0,0,.72-2.35c1-.48,2.55-1.81,3.75-5.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#64c86e"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPY;
exports["default"] = _default;